import React from 'react';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import PromotionalBannerTop, { ISiteBanner } from './promotional_banner_top';
import ReverbHeader from './reverb_header/reverb_header';
import SecondaryNagBanner from './secondary_nag_banner';

interface IProps {
  loginComponent?: React.ReactNode; // used to pass in an oauth login component from sandbox layout.tsx
  siteBanner?: ISiteBanner;
}

export function ReverbHeaderZone({ loginComponent, siteBanner }: IProps) {
  const user = useUser();
  const showSecondaryNagBanner = isExperimentEnabled(user, experiments.SECONDARY_HOMEPAGE_BANNER);

  return (
    <>
      <PromotionalBannerTop siteBanner={siteBanner} />
      <ReverbHeader loginComponent={loginComponent} />
      {showSecondaryNagBanner && <SecondaryNagBanner />}
    </>
  );
}

export default ReverbHeaderZone;
